import { Interval, ScheduleConfig } from "@superblocksteam/shared";
import { JobInterval } from "store/slices/apisV2/backend-types";
import type { JobTriggerConfig } from "store/slices/apisV2/backend-types";

const v1ToV2IntervalMap: Record<string, JobInterval> = {
  [Interval.Minute]: JobInterval.INTERVAL_MINUTE,
  [Interval.Hour]: JobInterval.INTERVAL_HOUR,
  [Interval.Day]: JobInterval.INTERVAL_DAY,
  [Interval.Week]: JobInterval.INTERVAL_WEEK,
  [Interval.Month]: JobInterval.INTERVAL_MONTH,
};

export const createV2Schedule = (
  v1Schedule: ScheduleConfig,
): Partial<JobTriggerConfig> => {
  const days = {
    sunday: v1Schedule.daysOfWeek[0],
    monday: v1Schedule.daysOfWeek[1],
    tuesday: v1Schedule.daysOfWeek[2],
    wednesday: v1Schedule.daysOfWeek[3],
    thursday: v1Schedule.daysOfWeek[4],
    friday: v1Schedule.daysOfWeek[5],
    saturday: v1Schedule.daysOfWeek[6],
  };
  if (Object.values(days).every((day) => !day)) {
    days.monday = true;
  }

  return {
    frequency: v1Schedule.frequency,
    interval:
      v1ToV2IntervalMap[v1Schedule.interval] ?? JobInterval.INTERVAL_MONTH,
    time: v1Schedule.time && v1Schedule.time.toISOString(),
    dayOfMonth: v1Schedule.dayOfMonth ?? 1,
    timezoneLocale: v1Schedule.timezoneLocale,
    days,
  };
};
